import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import { HttpRequestHelper } from 'app/helpers/httpRequestHelper';
import { ExposedListTranslationsRes } from 'app/interfaces/responses/Exposed/exposedListTranslationsRes';
import { HttpStatus } from 'app/interfaces/support/status/httpStatus';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root',
})
export class TranslocoHttpLoader implements TranslocoLoader {
    private httpRequestHelper = new HttpRequestHelper();

    constructor(private http: HttpClient) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get translation
     *
     * @param lang
     */
    getTranslation(lang: string): Promise<Translation> {
        return new Promise<Translation>((resolve, reject) => {
            this.http.get(environment.localApi + `translation/${lang}`, this.httpRequestHelper.getRequestOptionsAuth()).subscribe({
                next: (res: HttpStatus<ExposedListTranslationsRes[]>) => {
                    let translationMap: Translation = {};
                    res.returnItem.forEach((item) => (translationMap[item.translationKey] = item.translationValue));
                    resolve(translationMap);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }
}
